"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryTrialHistory = exports.queryFundingFeeRecord = exports.queryTransferRecords = void 0;
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../interface");
const utils_1 = require("./utils");
/**查询跨账户转账记录 */
function queryTransferRecords(params) {
    const instance = (0, trade_utils_lib_1.getTradeDependencyInstance)();
    const host = instance.getRunTimeHost().walletApiHost;
    const url = host + "/transfer_records/";
    return trade_utils_lib_1.Network.get({ url, data: params, authType: trade_utils_lib_1.AuthType.AccessAndSpot }).pipe((0, operators_1.map)((resp) => ((resp === null || resp === void 0 ? void 0 : resp.records) || []).filter((it) => it.status !== interface_1.TransferStatus.FAILED)));
}
exports.queryTransferRecords = queryTransferRecords;
/**查询当前账户资金费 */
function queryFundingFeeRecord(request) {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/trade/funding_fee",
        method: "GET",
        query: request,
    });
}
exports.queryFundingFeeRecord = queryFundingFeeRecord;
function queryTrialHistory(query) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trial/all_records",
        method: "GET",
        query,
    }).pipe((0, operators_1.map)((res) => res.records || []));
}
exports.queryTrialHistory = queryTrialHistory;
